var _path, _path2, _line, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 144,
    viewBox: "0 0 151 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.0023 63.7739C15.5024 64.454 15.0326 65.2242 15.0434 66.0753C15.0538 66.975 15.5959 67.7757 16.1299 68.5044C20.7649 74.8227 26.6848 80.9499 27.4436 88.7303C27.811 92.5054 26.8923 96.2561 26.6381 100.036C26.3839 103.816 26.9807 107.989 29.7207 110.618C33.0682 113.831 38.2615 113.616 42.6715 114.992C45.5567 115.89 48.1738 117.513 51.0033 118.581C53.8329 119.649 57.1152 120.118 59.7626 118.697C63.5706 116.654 64.6459 111.609 67.8291 108.686C71.0905 105.691 76.0078 105.407 80.4259 105.944C84.844 106.482 89.2855 107.678 93.6756 107.038C98.5248 106.332 102.754 103.467 107.421 101.994C111.672 100.653 116.223 100.487 120.518 99.2807C124.812 98.0746 129.106 95.4241 130.436 91.1491C132.161 85.566 128.297 79.771 128.028 73.9121C127.777 68.4688 130.638 63.4184 131.376 58.0323C132.702 48.3391 126.538 38.4227 117.819 33.9582C109.101 29.4938 98.4489 30.0036 89.5249 33.815C85.5011 35.5347 81.7106 37.8956 77.4445 38.8841C66.0267 41.5318 53.7287 33.9061 42.579 37.4573C35.4931 39.717 30.9583 45.8552 27.5223 52.1268C24.5402 57.571 19.5819 58.9039 16.0023 63.7739Z",
    fill: "#FF8787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9217 31.4537C72.8829 25.8453 80.881 25.748 83.9777 31.2827L107.915 74.0657C110.899 79.3983 107.044 85.9719 100.934 85.9719H54.4073C48.3826 85.9719 44.5198 79.5643 47.3328 74.2366L69.9217 31.4537Z",
    fill: "#E24C4C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.4102,
    y1: 43.9078,
    x2: 77.4102,
    y2: 66.9203,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4356,
    cy: 74.3227,
    r: 2.70125,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.dbec1e2f.svg";
export { ForwardRef as ReactComponent };